/** @format */

import { SVGProps } from 'react';

const ErrorIcon = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path
      d='M9 18a8.93 8.93 0 0 1-3.525-.7 8.937 8.937 0 0 1-2.862-1.912A8.94 8.94 0 0 1 .7 12.525 8.931 8.931 0 0 1 0 9c0-1.25.233-2.425.7-3.525a8.94 8.94 0 0 1 1.913-2.863A8.936 8.936 0 0 1 5.475.7C6.575.233 7.75 0 9 0s2.425.233 3.525.7a8.948 8.948 0 0 1 2.863 1.912A8.948 8.948 0 0 1 17.3 5.475c.467 1.1.7 2.275.7 3.525a8.93 8.93 0 0 1-.7 3.525 8.949 8.949 0 0 1-1.912 2.863 8.949 8.949 0 0 1-2.863 1.912A8.93 8.93 0 0 1 9 18Zm-.5-7.85h1v-6h-1v6Zm.5 3.3a.623.623 0 0 0 .438-.175.56.56 0 0 0 .187-.425.589.589 0 0 0-.187-.45.623.623 0 0 0-.438-.175.623.623 0 0 0-.438.175.589.589 0 0 0-.187.45.56.56 0 0 0 .187.425.623.623 0 0 0 .438.175Z'
      fill='#961100'
    />
  </svg>
);

export default ErrorIcon;
